"use client";

import { BSRHeartFilled } from "./bsr/BSRHeartFilled";
import { createBSRExperimentIcon } from "./createBSRExperimentIcon";
import { HeartSolid as LegacyHeartSolid } from "./legacy/HeartSolid";

export const HeartSolid = createBSRExperimentIcon(
  LegacyHeartSolid,
  BSRHeartFilled
);
